module.exports = __webpack_public_path__ + "static/media/header_micromachismo.819fb54d.jpg";